<template>
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex offer-provider-item align-items-center">
      <div :class="'offer-provider-branch offer-provider-' + id">{{ shortName }}</div>
      <div v-if="name" class="offer-provider-name">#{{ id }} {{ name }}</div>
    </div>
    <div class="d-flex align-items-center" style="gap: 0.5rem;">
      <b-badge
        v-if="status !== undefined && status === 0"
        variant="danger"
        class="ml-1"
      >
        Provider disabled
      </b-badge>
      <b-badge
        v-if="isSyncActive !== undefined && isSyncActive === 0"
        variant="danger"
        class="ml-1"
      >
        Provider Sync disabled
      </b-badge>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    status: {
      type: Number,
      required: false
    },
    isSyncActive: {
      type: Number,
      required: false
    }
  },
  computed: {
    shortName () {
      switch (parseInt(this.id)) {
      case 1:
        return 'AY'
      case 2:
        return 'BL'
      case 3:
        return 'BE'
      case 4:
        return 'AS'
      case 5:
        return 'AD'
      case 6:
        return 'MA'
      case 7:
        return 'MF'
      case 50:
        return 'DS'
      case 60:
        return 'AF'
      }
      return 'UNKNOWN'
    }
  }
}
</script>
